<h2 mat-dialog-title>Document Type</h2>

<mat-dialog-content [formGroup]="formGroup">
    <lgd-select controlName="selectedType" label="Doc Type" [options]="selectedTypesObservable" aria-label="Type Options">
    </lgd-select>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" telemetry="Submission-DocTypeCancel">
        Cancel
    </button>

    <button mat-button (click)="confirm()" telemetry="Submission-DocTypeConfirm">
        Confirm
    </button>
</mat-dialog-actions>